import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {useFormikContext } from "formik";
import { Field } from "formik";
import { Switch as MuiSwitch } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";


import useStyles from "assets/jss/material-dashboard-react/components/customSwitchStyle";
import { useState } from "react";
import { useEffect } from "react";

const MuSwitch = withStyles({
  opacity: 0.6,
  switchBase: {
      "&$checked": {
          color: "#d50910",
          opacity: 0.6
      },
      "&$checked + $track": {
          backgroundColor: "#d50910",
          opacity: 0.6
      },
  },
  checked: {},
  track: {}
})(MuiSwitch); 


const Switch = (props) => {
  const { t } = useTranslation();
  const { name, label, labelLeft, labelRight,disabled,getValue=()=>{} } = props;
  const classes = useStyles();
  const [checked,setChecked]= useState(false);

    const formik = useFormikContext();

    

  return (
    <Field name={name} >
      {(props) => {
        const { field, meta } = props;
        useEffect(() => {
          getValue(meta)
      });

        return (

          <Grid container spacing={1} alignItems="center" justify="flex-start">
            <Grid item xs={12}>
              <InputLabel

                htmlFor={name}
                className={clsx(classes.label, {
                  [classes.error]: meta.touched && meta.error,
                })}
                
              >
                {t(label)}
              </InputLabel>
            </Grid>
            <Grid item>{t(labelLeft)}</Grid>
            <Grid item>
              <MuSwitch
                {...field}
                name={name}
                checked={meta.value}
                
                color="primary"
                disabled = {disabled}
                />
            </Grid>
            <Grid item>{t(labelRight)}</Grid>
          </Grid>
        );
      }}
    </Field>
  );
};

Switch.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  meta: PropTypes.object,
  field: PropTypes.object,
  disabled: PropTypes.bool,
  getValue: PropTypes.func,

};

export default Switch;
